import { render, staticRenderFns } from "./Thead.vue?vue&type=template&id=d21f8452&"
import script from "./Thead.vue?vue&type=script&lang=ts&"
export * from "./Thead.vue?vue&type=script&lang=ts&"
import style0 from "./Thead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports